import "./signup.css";
import { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

export default function Signup() {
  let history = useHistory();
  const [first_name, setFirstusername] = useState("");
  const [last_name, setSecusername] = useState("");
  const [email, setEmail] = useState("");
  const [number, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConpassword] = useState("");
  const [registerstatus, setRegistermessage] = useState("");

  const createAccount = async (e) => {
    e.preventDefault();
    try {
      await axios
        .post("https://services.lafemasystems.co.ke/api/create", {
          first_name,
          last_name,
          email,
          number,
          password,
        })
        .then((response) => {
          if (response.data.success === 0) {
            setRegistermessage(response.data.data);
          } else {
            setRegistermessage("Registered Successfully");
            history.push("/account");
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  const tryCreactingaccount = async (e) => {
    e.preventDefault();
    if (
      first_name.length !== 0 &&
      last_name.length !== 0 &&
      email.length !== 0 &&
      number.length !== 0 &&
      password.length !== 0
    ) {
      if (password.localeCompare(confirmpassword) !== 0) {
        setRegistermessage("! Passwords must march");
      } else if (password.length < 4 || confirmpassword < 4) {
        setRegistermessage("! Password must be atleast 4 digits");
      } else {
        setRegistermessage("Veryfying Details");
        //await new Promise((resolve) => setTimeout(resolve, 2000));
        createAccount(e);
      }
    } else {
      setRegistermessage("! Fill in all fields");
    }
  };

  return (
    <form className="createaccount">
      <h1>Create Account</h1>
      <input
        type="text"
        placeholder="FIRST NAME"
        onChange={(e) => {
          setFirstusername(e.target.value);
        }}
      />
      <input
        type="text"
        placeholder="LAST NAME"
        onChange={(e) => {
          setSecusername(e.target.value);
        }}
      />
      <input
        type="email"
        placeholder="EMAIL"
        onChange={(e) => {
          setEmail(e.target.value);
        }}
      />
      <input
        type="phone"
        placeholder="PHONE NUMBER"
        onChange={(e) => {
          setPhone(e.target.value);
        }}
      />
      <input
        type="password"
        placeholder="PASSWORD"
        onChange={(e) => {
          setPassword(e.target.value);
        }}
      />
      <input
        type="password"
        placeholder="CONFIRM PASSWORD"
        onChange={(e) => {
          setConpassword(e.target.value);
        }}
      />
      <b>{registerstatus}</b>

      <button className="buttoo" onClick={tryCreactingaccount}>
        REGISTER
      </button>
    </form>
  );
}
